import React, { useState } from 'react';
import { Button, Form, Image, Row, Col, Carousel } from 'react-bootstrap';

// Componente recursivo para exibir um comentário e suas respostas
const Comment = ({ comment, onReplySubmit }) => {
    const [showReplyForm, setShowReplyForm] = useState(false);
    const [replyText, setReplyText] = useState('');

    const handleReply = () => {
        if (!replyText.trim()) return;
        // Chama a função do pai, passando o texto e o ID do comentário pai
        onReplySubmit(replyText, comment.id);
        setReplyText('');
        setShowReplyForm(false);
    };

    return (
        <div className="mb-2" style={{ marginLeft: comment.parent_id ? '20px' : '0px', borderLeft: comment.parent_id ? '2px solid #eee' : 'none', paddingLeft: comment.parent_id ? '10px' : '0px' }}>
            <div>
                <strong>{comment.user?.nome || 'Usuário'}:</strong>
                {/* Exibe a mídia anexada ao comentário em um Carrossel */}
                {comment.media && comment.media.length > 0 && (
                    <Carousel
                        interval={null} // Para não girar automaticamente
                        indicators={comment.media.length > 1} // Mostra indicadores se houver mais de 1 item
                        className="mt-2 mb-2 rounded shadow-sm bg-light"
                    >
                        {comment.media.map(mediaItem => (
                            <Carousel.Item key={mediaItem.id}>
                                {mediaItem.mime_type && mediaItem.mime_type.startsWith('video/') ? (
                                    <video
                                        src={mediaItem.original_url}
                                        controls
                                        style={{ width: '100%', height: 'auto', maxHeight: '300px', borderRadius: '0.375rem' }}
                                    >
                                        Seu navegador não suporta o elemento de vídeo.
                                    </video>
                                ) : (
                                    <Image
                                        src={mediaItem.original_url}
                                        alt={`Mídia de ${comment.user?.nome}`}
                                        className="d-block w-100"
                                        style={{ maxHeight: '300px', objectFit: 'contain', margin: 'auto' }}
                                    />
                                )}
                            </Carousel.Item>
                        ))}
                    </Carousel>
                )}
                <p className="mb-1 bg-light p-2 rounded">{comment.body}</p>
                <Button variant="link" size="sm" onClick={() => setShowReplyForm(!showReplyForm)}>
                    {showReplyForm ? 'Cancelar' : 'Responder'}
                </Button>
            </div>

            {showReplyForm && (
                <Form onSubmit={(e) => { e.preventDefault(); handleReply(); }} className="mt-2">
                    <Form.Group>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder={`Respondendo a ${comment.user?.nome}...`}
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" size="sm" className="mt-2">Enviar Resposta</Button>
                </Form>
            )}

            {/* Renderiza as respostas recursivamente */}
            {comment.replies && comment.replies.length > 0 && (
                <div className="mt-2">
                    {comment.replies.map(reply => <Comment key={reply.id} comment={reply} onReplySubmit={onReplySubmit} />)}
                </div>
            )}
        </div>
    );
};

export default Comment;